export default "__VITE_ASSET__B$B2Byod__"